const COINS_BLOG_SLUGS = ["@blog", "@dario_en_paragraph"]

export function getCoinsFlag(blogSlug: string, postTime: number): boolean {
  const flag =
    process.env.NEXT_PUBLIC_VERCEL_ENV !== "production" &&
    // The post was published after May 27th, 2025
    postTime > 1748304000 &&
    COINS_BLOG_SLUGS.includes(decodeURIComponent(blogSlug))

  return flag
}
